<script>
import Divider from "@/components/atoms/divider";
import ButtonIcon from "@/components/molecules/button-icon";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Popin from "@/components/molecules/popin";
import FormGroup from "@/components/molecules/form-group";
import FormRadio from "@/components/molecules/form-radio";
import Titre from "@/components/atoms/titre";
import MesDefis from "@/containers/mes-defis";
import FideliteCarteInfo from "@/containers/fidelite-carte-info";
import carteMastercard from "@/assets/images/cora-mastercard.png";
import carteMalin from "@/assets/images/carte-malin.png";
import illuEurocora from "@/assets/images/defis/illu-eurocora.svg";
import BandeauGoodNewsCarrefour from "@/components/organisms/bandeau-good-news-carrefour";
import BandeauCarteCarrefourRegistered from "@/components/organisms/bandeau-carte-carrefour-registered";
import { soldeEuros } from "@/utils/solde-euro-cora";
import PopinAppairage from "@/containers/carrefour-appairage-fid";

import {
  monCompteMaFideliteEmits,
  monCompteMaFideliteProps,
  useMonCompteMaFidelite
} from "./mixin";
export default {
  name: "MaFideliteMobile",
  components: {
    FideliteCarteInfo,
    MesDefis,
    Divider,
    ButtonIcon,
    Button,
    LazyImage,
    Popin,
    FormGroup,
    FormRadio,
    Titre,
    BandeauGoodNewsCarrefour,
    BandeauCarteCarrefourRegistered,
    PopinAppairage
  },
  props: {
    ...monCompteMaFideliteProps()
  },
  emits: ["changeCard", ...monCompteMaFideliteEmits()],
  setup(props, context) {
    const { addNewCard, cardSelectedLibelleData, filterFid } =
      useMonCompteMaFidelite(props, context);
    return {
      addNewCard,
      cardSelectedLibelleData,
      carteMastercard,
      carteMalin,
      illuEurocora,
      filterFid
    };
  },
  methods: {
    changeCard() {
      this.$emit("changeCard", this.cardSelectedLibelleData);
      this.$refs.changeCartePopin.hide();
    },
    soldeEuros(carte) {
      return (
        parseFloat(carte.attributes.solde_euro) +
        parseFloat(carte.attributes.solde_euro_suiv ?? 0)
      );
    }
  }
};
</script>
<template>
  <div>
    <div class="u-mx-sm u-mb-md">
      <p class="u-mb-sm">
        Sélectionnez votre carte de fidélité :
      </p>
      <ButtonIcon
        full-width
        align="left"
        icon-name="arrow-down"
        icon-size="sm"
        icon-position="right"
        variant="grey-4"
        outline
        size="md"
        radius="md"
        icon-color="black"
        @click="$refs.changeCartePopin.show()"
      >
        <div class="u-flex u-py-sm u-flex-align-center">
          <LazyImage
            :src="getImgCardType(cardSelected.attributes.sous_type)"
            width="48"
            height="30"
            alt=""
            class="u-mr-sm"
            :class="cardSelected.attributes.expired && 'c-ma-fidelite-mobile__card-img--expiree'"
          />
          Ma carte {{ getCardType(cardSelected.attributes.sous_type) }}
        </div>
      </ButtonIcon>
      <Popin
        ref="changeCartePopin"
        slide-up
      >
        <Titre
          tag="h2"
          size="md"
          variant="primary"
          class="u-mb-md u-text-center"
        >
          Sélectionnez votre carte de fidélité
        </Titre>
        <FormGroup class="c-ma-fidelite-mobile__card-wrapper">
          <FormRadio
            v-for="carte in filterFid"
            :key="carte.id"
            v-model="cardSelectedLibelleData"
            block
            name="carte"
            :value="carte.attributes.type_carte"
            class="u-mb-xs"
          >
            <LazyImage
              :src="getImgCardType(carte.attributes.sous_type)"
              class="u-flex-shrink-none u-mr-xs"
              width="63"
              height="40"
              :class="carte.attributes.expired && 'c-ma-fidelite-mobile__card-img--expiree'"
              :alt="`Carte ${carte.attributes.type_carte}`"
            />
            <div>
              <p>Ma carte {{ getCardType(carte.attributes.sous_type) }}</p>
              <div
                v-if="soldeEuros(carte)"
                class="u-flex"
              >
                <LazyImage
                  :src="illuEurocora"
                  height="16"
                  width="16"
                  alt=""
                  class="u-mr-xxs"
                />
                <span class="u-font-12 u-font-700">{{ formatPrix(soldeEuros(carte)) }} €</span>
              </div>
            </div>
          </FormRadio>
          <div
            v-if="filterFid.length === 1 "
            class="u-text-center u-mt-lg20"
          >
            <Button
              link
              variant="text-light"
              @click="addNewCard()"
            >
              <span class="u-font-16">
                + Ajouter une carte
              </span>
            </Button>
          </div>
        </FormGroup>
        <div
          class="u-text-center u-mt-md"
          :class="fidelite.length > 1 && 'u-mt-xlg'"
        >
          <Button
            size="lg25"
            radius="full"
            variant="primary"
            @click="changeCard()"
          >
            Valider
          </Button>
        </div>
      </Popin>
    </div>
    <div class="u-bgcolor-white">
      <FideliteCarteInfo
        :carte="cardSelected"
        class="u-p-sm"
      />
      <template v-if="!cardSelected.attributes.expired">
        <div class="u-p-sm">
          <BandeauGoodNewsCarrefour
            v-if="!cardSelected.attributes.num_carte_carrefour  && cardSelected.attributes.is_data_live"
            @enregistrerCarte="$refs.popinAppairage.show()"
          />
          <BandeauCarteCarrefourRegistered
            v-else-if="!!cardSelected.attributes.num_carte_carrefour"
            :num-carte-carrefour="cardSelected.attributes.num_carte_carrefour"
          />
        </div>
        <Divider
          dotted
          class="u-my-none u-mx-sm"
        />
        <MesDefis
          v-if="!errorDefis"
          :type-carte="cardSelectedLibelleData"
          is-mobile
        />
        <p
          v-else
          class="u-color-alert u-font-14 u-py-md u-mx-sm"
        >
          Désolé, une erreur s’est produite lors de la récupération de vos défis. Veuillez réessayer plus tard
        </p>
      </template>
    </div>
  </div>
  <PopinAppairage
    ref="popinAppairage"
    :type-carte-selected="cardSelectedLibelleData"
    :cards="fidelite"
  />
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/ma-fidelite-mobile";
</style>
